<div class="leads-main-page records-page">
    <div class="datatable-page-shell">
        <div class="records-page__hero leads-main-hero">
            <div class="records-page__hero-primary">
                <div class="records-page__hero-headline">
                    <span class="records-page__hero-eyebrow">{{ 'LEADS' | translate }}</span>
                    <h3 class="records-page__hero-title">{{ 'YOUR_LEADS' | translate }}</h3>
                </div>
            </div>
            <div class="records-page__hero-aside">
                <div class="records-page__hero-actions">
                    <ng-select class="saved-search-select" [items]="leadSavedSearches" bindLabel="name" bindValue="id"
                        [placeholder]="'SAVED_SEARCHES' | translate" [(ngModel)]="selectedSavedSearchId"
                        (ngModelChange)="onSavedSearchChange($event)" [clearable]="true">
                    </ng-select>
                    <button *ngIf="doWhat.isAdmin || doWhat.canCreate" type="button" class="blue-button" (click)="onAddNew()">{{ 'ADD_LEAD' | translate }}</button>
                </div>
            </div>
        </div>

        <div class="details-tab-surface leads-main-surface datatable-page-surface">
            <app-campaign-datatable class="records-page__table" [iCanRead]="doWhat.canRead" [iCanWrite]="doWhat.canWrite" [iCanDelete]="doWhat.canDelete"
                [iColumns]="columns" (oDeleteRows)="onDelete($event)" [iRowLinkHandler]="getRowLink" [iIsServerLoading]="true"
                [iTotalCount]="leadsTotalCount" (oCustomDataExport)="exportLeads()" [iIsCustomDataExport]="true"
                [iData$]="leadsData" (oEditRow)="onEdit($event)" (oLoadDataFromServer)="onLoadingData($event)" [iShowSelect]="false"
                iSortColumn="createdAt" iSortDirection="desc" (oAddNew)="onAddNew()" [iShowSelect]="true">
            </app-campaign-datatable>
        </div>
    </div>
</div>

<ngx-spinner bdColor="rgba(0, 0, 0, 0.8)" size="medium" color="#000" type="ball-spin-clockwise" [fullScreen]="true">
    <p style="color: white">{{ 'DATA_EXPORT_IN_PROGRESS' | translate }}</p>
</ngx-spinner>
